var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 143,
    viewBox: "0 0 400 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h400v143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h100.716v100.716H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#FEE",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F8E6E6",
    d: "M.5.5h399v142H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#80959D",
    fillRule: "nonzero",
    opacity: 0.2,
    transform: "translate(222.057 38.115)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.076 33.627h45.855V4.076H4.076v29.551zM0 0h54.007v37.703H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.171 27.513l6.115-17.323 10.981 12.407 6.341-3.05v7.966z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.779,
    cy: 14.266,
    r: 4.076
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.104 7.04l43.533 24.646-16.229 27.548-5.988-3.213.387 5.462 7.762 4.132 21.088-35.81L33.215.116l-15.381 27.16 6.28-1.172z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.179,
    cy: 37.703,
    r: 4.076,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.627 25.475h10.19l-1.85-8.152z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M86 45h107.399v6.683H86z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6DCDE",
    d: "M86 88h53v20H86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3238",
    d: "M96.942 94.861h2.12c.983 0 1.693.144 2.13.43.439.286.658.739.658 1.357 0 .417-.108.764-.323 1.04-.215.277-.524.451-.927.523v.049c.5.094.87.28 1.106.559.236.278.354.655.354 1.13 0 .641-.224 1.144-.672 1.507-.447.363-1.07.544-1.867.544h-2.579v-7.139zm1.167 2.95h1.123c.489 0 .845-.078 1.07-.232.224-.155.337-.418.337-.789 0-.335-.122-.578-.364-.728-.243-.15-.628-.224-1.155-.224h-1.01v1.973zm0 .947v2.26h1.24c.489 0 .858-.093 1.107-.28.249-.187.373-.483.373-.886 0-.372-.127-.647-.38-.826-.255-.179-.64-.268-1.158-.268h-1.182zm8.934 3.242l-.161-.708h-.059c-.16.25-.386.448-.68.59-.296.144-.632.216-1.01.216-.654 0-1.142-.163-1.464-.489-.322-.325-.483-.818-.483-1.48V96.6h1.157v3.33c0 .414.084.724.254.93.169.208.434.31.796.31.481 0 .835-.143 1.062-.431.226-.288.339-.77.339-1.448V96.6h1.152v5.4h-.903zm4.363-.83c.28 0 .56-.044.84-.132v.864c-.127.056-.29.102-.49.14a3.38 3.38 0 0 1-.623.056c-1.087 0-1.631-.573-1.631-1.72v-2.91h-.737v-.507l.79-.42.391-1.143h.708V96.6h1.538v.869h-1.538v2.89c0 .277.07.481.208.613.138.132.32.198.544.198zm3.743 0c.28 0 .56-.044.84-.132v.864c-.127.056-.29.102-.49.14a3.38 3.38 0 0 1-.623.056c-1.087 0-1.63-.573-1.63-1.72v-2.91h-.738v-.507l.79-.42.391-1.143h.708V96.6h1.539v.869h-1.539v2.89c0 .277.07.481.208.613.138.132.32.198.544.198zm6.522-1.88c0 .882-.226 1.57-.679 2.065-.452.495-1.082.743-1.89.743a2.59 2.59 0 0 1-1.337-.342 2.256 2.256 0 0 1-.894-.982c-.208-.426-.312-.92-.312-1.484 0-.876.224-1.56.673-2.05.45-.492 1.083-.738 1.9-.738.781 0 1.4.251 1.855.754.456.503.684 1.181.684 2.034zm-3.93 0c0 1.247.46 1.87 1.381 1.87.912 0 1.367-.623 1.367-1.87 0-1.234-.459-1.85-1.377-1.85-.481 0-.83.159-1.047.478-.217.319-.325.776-.325 1.372zm9.812 2.71H126.4v-3.32c0-.417-.083-.728-.251-.933-.168-.205-.434-.308-.798-.308-.485 0-.84.144-1.065.43-.224.287-.337.767-.337 1.44V102h-1.147v-5.4h.898l.161.708h.059c.163-.258.394-.456.693-.596.3-.14.632-.21.996-.21 1.296 0 1.944.66 1.944 1.977V102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M86 61h83.532v6.683H86z",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26);
export default __webpack_public_path__ + "static/media/group-26.c871f9931dd169683b5b9f8a3d9df41c.svg";
export { ForwardRef as ReactComponent };